import { Controller } from "@hotwired/stimulus"

// Per-scene controls for the Beat-Synced Short builder: media uploads
// (image/video) and debounced field updates (duration, motion, caption…).
export default class extends Controller {
  static values = { uploadUrl: String, updateUrl: String, segmentIndex: Number }
  static targets = ["imageInput", "videoInput"]

  pickImage() { this.imageInputTarget.click() }
  pickVideo() { this.videoInputTarget.click() }

  async onFile(event) {
    const input = event.target
    const file = input.files && input.files[0]
    if (!file) return
    const assetType = input.dataset.assetType

    const body = new FormData()
    body.append("segment_index", this.segmentIndexValue)
    body.append("asset_type", assetType)
    body.append("file", file)

    input.disabled = true
    try {
      const res = await fetch(this.uploadUrlValue, { method: "POST", headers: this.headers(), body })
      if (res.ok) {
        window.location.reload() // refresh to show the new thumbnail
      } else {
        const data = await res.json().catch(() => ({}))
        alert(`Upload failed: ${data.error || res.status}`)
      }
    } finally {
      input.disabled = false
      input.value = ""
    }
  }

  updateField(event) {
    const field = event.target.dataset.field
    if (!field) return
    const value = event.target.value

    clearTimeout(this._t)
    this._t = setTimeout(() => {
      fetch(this.updateUrlValue, {
        method: "PATCH",
        headers: { ...this.headers(), "Content-Type": "application/json" },
        body: JSON.stringify({ segment_index: this.segmentIndexValue, [field]: value })
      }).then((res) => {
        const el = event.target
        el.classList.add(res.ok ? "ring-1" : "ring-2", res.ok ? "ring-green-300" : "ring-red-400")
        setTimeout(() => el.classList.remove("ring-1", "ring-2", "ring-green-300", "ring-red-400"), 600)
      })
    }, 350)
  }

  headers() {
    return { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content }
  }
}
